<template>
  <footer>
    <div class="fotter-area d-dark-bg">
        <div class="footer__top pt-80 pb-15">
            <div class="container">
                <div class="row">
                    <div class="col-xl-5 col-lg-4 order-last-md">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="footer__widget">
                                    <div class="footer__widget-title">
                                        <h4>Customer Care</h4>
                                    </div>
                                    <div class="footer__widget-content">
                                        <div class="footer__link">
                                            <ul>
                                                <li><router-link href="/faq">New Customers</router-link></li>
                                                <li><router-link href="/faq">How to use Account</router-link></li>
                                                <li><router-link href="/faq">Placing an Order</router-link></li>
                                                <li><router-link href="/faq">Payment Methods</router-link></li>
                                                <li><router-link href="/faq">Delivery &amp; Dispatch</router-link></li>
                                                <li><router-link href="/faq">Problems with Order</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="footer__widget">
                                    <div class="footer__widget-title">
                                        <h4>Customer Service</h4>
                                    </div>
                                    <div class="footer__widget-content">
                                        <div class="footer__link">
                                            <ul>
                                                <li><router-link href="/faq">Help Center</router-link></li>
                                                <li><router-link href="/faq">Contact Us</router-link></li>
                                                <li><router-link href="/faq">Report Abuse</router-link></li>
                                                <li><router-link href="/faq">Submit a Dispute</router-link></li>
                                                <li><router-link href="/faq">Policies &amp; Rules</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-7 col-lg-8 order-first-md">
                        <div class="footer__top-left">
                            <div class="row">
                                <div class="col-xl-7 col-lg-6 col-md-6 col-sm-6">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                            <div class="footer__widget">
                                                <div class="footer__widget-title">
                                                    <h4>My Account</h4>
                                                </div>
                                                <div class="footer__widget-content">
                                                    <div class="footer__link">
                                                        <ul>
                                                            <li><router-link href="/faq">Product Support</router-link></li>
                                                            <li><router-link href="/checkout">Checkout</router-link></li>
                                                            <li><router-link href="/cart">Shopping Cart</router-link></li>
                                                            <li><router-link href="/wishlist">Wishlist</router-link></li>
                                                            <li><router-link href="/faq">Terms &amp; Conditions &amp;</router-link></li>
                                                            <li><router-link href="/faq">Redeem Voucher</router-link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                <div class="footer__widget">
                                    <div class="footer__widget-title">
                                        <h4>Quick Links</h4>
                                    </div>
                                    <div class="footer__widget-content">
                                        <div class="footer__link">
                                            <ul>
                                                <li><router-link href="/contact">Store Location</router-link></li>
                                                <li><router-link href="/my-account">My account</router-link></li>
                                                <li><router-link href="/contact">Order Tracking</router-link></li>
                                                <li><router-link href="/faq">FAQs</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div></div>
                                </div><div class="col-xl-5 col-lg-6 col-md-6 col-sm-6">
                                    <div class="footer__widget">
                                        <div class="footer__widget-title mb-20">
                                            <h4>About The Store</h4>
                                        </div>
                                        <div class="footer__widget-content">
                                            <p class="footer-text mb-35">Our mission statement is to provide the absolute best customer experience available in the Electronic industry without exception.</p>
                                            <div class="footer__hotline d-flex align-items-center mb-10">
                                                <div class="icon mr-15">
                                                    <i class="fas fa-headset"></i>
                                                </div>
                                                <div class="text">
                                                    <h4>Got Question? Call us 24/7!</h4>
                                                    <span><a href="tel:100-123-456-7890">(+94)071 5990 499</a></span>
                                                </div>
                                            </div>
                                            <div class="footer__info">
                                                <ul>
                                                    <li>
                                                        <span>Add:  <a target="_blank" href="#">No. 56, HighLevel Road, Homagama</a></span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer__bottom">
            <div class="container">
                <div class="footer__bottom-content pt-55 pb-45">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="footer__links text-center mb-25">
                                <p>
                                    <router-link href="#">Online Shopping</router-link>
                                    <router-link href="#">Promotions</router-link>
                                    <router-link href="#">My Orders</router-link>
                                    <router-link href="#">Help</router-link>
                                    <router-link href="#">Customer Service</router-link>
                                    <router-link href="#">Support</router-link>
                                    <router-link href="#">Most Populars</router-link>
                                    <router-link href="#">New Arrivals</router-link>
                                    <router-link href="#">Special Products </router-link>
                                    <router-link href="#">Manufacturers</router-link>
                                    
                                </p>
                            </div>
                            <div class="payment-image text-center mb-25">
                                <router-link href="/contact"><img src="/images/payment/payment.png" alt=""></router-link>
                            </div>
                            <div class="copy-right-area text-center">
                                <p>Copyright © <span>Sallelanka Solutions (pvt) Ltd.</span> All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </footer>
</template>

<script setup>

</script>
